(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
const schemata = require('schemata')
const required = require('@clocklimited/validity-required')

module.exports = function () {
  return schemata(
    { type:
      { type: String
      }
    , amount:
      { type: String
      }
    , date:
      { type: Date
      , validators:
        { all: [ required ]
        }
      }
    , notes:
      { type: String
      }
    , status:
      { type: String
      }
    , company:
      { type: String
      }
    }
  )
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/components/service/contract/payment-schedule-schema.js","/components/service/contract")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvbXBvbmVudHMvc2VydmljZS9jb250cmFjdC9wYXltZW50LXNjaGVkdWxlLXNjaGVtYS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBIiwiZmlsZSI6ImdlbmVyYXRlZC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCBzY2hlbWF0YSA9IHJlcXVpcmUoJ3NjaGVtYXRhJylcbmNvbnN0IHJlcXVpcmVkID0gcmVxdWlyZSgnQGNsb2NrbGltaXRlZC92YWxpZGl0eS1yZXF1aXJlZCcpXG5cbm1vZHVsZS5leHBvcnRzID0gZnVuY3Rpb24gKCkge1xuICByZXR1cm4gc2NoZW1hdGEoXG4gICAgeyB0eXBlOlxuICAgICAgeyB0eXBlOiBTdHJpbmdcbiAgICAgIH1cbiAgICAsIGFtb3VudDpcbiAgICAgIHsgdHlwZTogU3RyaW5nXG4gICAgICB9XG4gICAgLCBkYXRlOlxuICAgICAgeyB0eXBlOiBEYXRlXG4gICAgICAsIHZhbGlkYXRvcnM6XG4gICAgICAgIHsgYWxsOiBbIHJlcXVpcmVkIF1cbiAgICAgICAgfVxuICAgICAgfVxuICAgICwgbm90ZXM6XG4gICAgICB7IHR5cGU6IFN0cmluZ1xuICAgICAgfVxuICAgICwgc3RhdHVzOlxuICAgICAgeyB0eXBlOiBTdHJpbmdcbiAgICAgIH1cbiAgICAsIGNvbXBhbnk6XG4gICAgICB7IHR5cGU6IFN0cmluZ1xuICAgICAgfVxuICAgIH1cbiAgKVxufVxuIl19